module.exports = __webpack_public_path__ + "static/media/replate.402f566b.jpg";